export default "__VITE_PUBLIC_ASSET__e7bba10c__"